/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import * as React from 'react';
import { IntlProvider as ReactIntlProvider } from 'react-intl';

// Our translated strings
import Locales from './locales';

/*
 * Define user's language. Different browsers have the user locale defined
 * on different fields on the `navigator` object, so we make sure to account
 * for these different by checking all of them
 */
export const locale = 'en-US';

/*
 * Original `language` value with locale detection
 * const locale =
 *   (navigator.languages && navigator.languages[0]) ||
 *   navigator.language ||
 *   navigator.userLanguage
 */

/*
 * Split locales with a region code
 * const languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0]
 */

// Try full locale, try locale without region code, fallback to 'en'
export const messages = Locales.en;

export const suffixes = {
  'en-US': {
    one: 'st',
    two: 'nd',
    few: 'rd',
    other: 'th',
    many: 'th',
    zero: ',',
  },
};

export const pluralRules = new Intl.PluralRules(locale, { type: 'ordinal' });

/*
 * Original `messages` value with locale detection
 * const messages =
 *   Locales[languageWithoutRegionCode] || Locales[language] || Locales.en
 */

export default function IntlProvider({
  children = null,
}: {
  children: React.ReactNode;
}) {
  return (
    <ReactIntlProvider
      locale={locale}
      messages={messages}
      defaultRichTextElements={{
        b: (chunks) => <b>{chunks}</b>,
      }}
    >
      {children}
    </ReactIntlProvider>
  );
}
